import { Steps } from "antd"
import { useLocation } from "react-router-dom";
import useGetLang from "../../hooks/useGetLang";

const Step = () => {
    const location = useLocation();

    const getCurrentStep = (pathname) => {
        switch (pathname) {
            case '/select_step/ticket':
                return 0;
            case '/select_step/cart':
                return 1;
            case '/select_step/payment':
                return 2;
            default:
                return 0;
        }
    };

    const currentStep = getCurrentStep(location.pathname);
    return (
        <Steps
            current={currentStep}
            labelPlacement="vertical"
            items={[
                {
                    title: useGetLang('step_select_ticket'),
                    // status: 'finish',
                    // icon: <UserOutlined />,
                },
                // {
                //     title: 'Chọn ngày',
                //     // status: 'finish',
                //     // icon: <SolutionOutlined />,
                // },
                {
                    title: useGetLang('step_book_ticket'),
                    // status: 'process',
                    // icon: <LoadingOutlined />,
                },
                {
                    title: useGetLang('step_payment'),
                    // status: 'wait',
                    // icon: <SmileOutlined />,
                },
            ]}
        />
    )
}

export default Step